import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
    row1 : [
    {
        column: "column1",
        columnWidth: "40%",
        rows: {
            row1: [
                {
                  name: "exportProductOtherdetailsAccessories",
                  label: "Accessories",
                  component: "dropdown",
                  iconColor: "gray-400",
                  endIconName: LuChevronDown,
                  defaultValue: "NoAccess",
                  options: [
                    { label: "No Accessories", value: "No Accessories" },
                    { label: "Accessory included", value: "Accessory included" },
                    {
                      label: "Accessory included in another",
                      value: "Accessory included in another",
                    },
                  ],
                },
              ],
            row2: [
                {
                    name: "exportProductOtherdetailsThirdpartyExport",
                    component: "checkboxbox",
                    checkboxLabel: "This is a Third Party Export",
                },
            ],
            row3: [
                {
                    name: "exportProductOtherdetailsName",
                    label: "Name",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type:"autocomplete",
                    endpoint:"getCustomers",
                    autofillTargets: {
                       "exportProductOtherdetailsTBEState": "state",
                        "exportProductOtherdetailsTBEAddress":"addressLine",
                        "exportProductOtherdetailsTBEIECode":"ieCodeNo",
                        "exportProductOtherdetailsTBEBranchSerialNo":"branchNo"
                      },
                      endPointWithId : "getCustomersAddress"
                }

            ],
            row4: [
                {
                    name: "exportProductOtherdetailsTBEIECode",
                    label: "IE Code",
                    component: "text-field",
                },
                {
                    name: "exportProductOtherdetailsTBEBranchSerialNo",
                    label: "Branch SNo",
                    component: "text-field",
                    dataType: "int",
                }

            ],
            row5: [
                {
                    name: "exportProductOtherdetailsTBERegistrationNo",
                    label: "Regn.No",
                    component: "dropdown",
                    endIconName: "LuChevronDown",
                    iconColor: "gray-400",
                    defaultValue: "Regno",
                    width : "50%",
                    options: [
              {
                label: "GSTIN of Normal Person /Individual IEC",
                value: "GSTIN of Normal Person /Individual IEC",
              },
              {
                label: "GSTIN of Government Entities",
                value: "GSTIN of Government Entities",
              },
              { label: "GSTIN of Diplomats", value: "GSTIN of Diplomats" },
              {
                label: "GSTIN of Non-Resident Taxable Person",
                value: "GSTIN of Non-Resident Taxable Person",
              },
              { label: "PAN Number", value: "PAN Number" },
              { label: "TAN Number", value: "TAN Number" },
              { label: "Passport No", value: "Passport No" },
              { label: "Aadhar Number", value: "Aadhar Number" },
            ],


                },
                {
                    name: "exportProductOtherdetailsTBERegistrationNoType",
                    component: "text-field",
                }

            ],
            row6: [
                {
                    name: "exportProductOtherdetailsTBEState",
                    label: "Address",
                    component: "text-field",
                    icon: LuChevronDown,
                    isGet:false


                },

            ],
            row7: [
                {
                    name: "exportProductOtherdetailsTBEAddress",
                    component: "textarea",
                    labelGap: false,
                    height: 100,
                    width : "90%",
                    sx: {
                        borderRadius: "12px"
                    },

                },


            ]
        }
    },
    {
        column: "column2",
        columnWidth: "40%",
        rows: {
            row1: [
                {
                  name: "exportProductOtherdetailsAccDescription",
                  component: "textarea",
                  labelGap: false,
                  height: 100,
                  sx: { borderRadius: "12px" },
                  dependsOn: "Accessories",
                  enableWhen: (val) => ["Accessory included"].includes(val), 
                },
              ],
            row2: [

                {
                    name: "Manufacturer/Producer/Grower Details",

                    component: "header",
                    label: "Manufacturer/Producer/Grower Details"

                }
            ],
            row3: [
                {
                    name: "exportProductOtherdetailsProducerName",
                    label: "Name",
                    component: "text-field",
                }

            ],
            row4: [
                {
                    name: "exportProductOtherdetailsProducerCodePrefix",
                    label: "Code",
                    component: "text-field",
                    width: "40%"
                },
                {
                    name: "exportProductOtherdetailsProducerCode",
                    component: "text-field",
                    width: "60%"
                }

            ],
            row5: [

                {
                    name: "exportProductOtherdetailsProducerAddress",
                    actionText: "Address",

                    component: "textarea",
                    height: 100,
                    sx: {
                        borderRadius: "12px"
                    },
                    labelGap: false,
                }

            ],
            row6: [
                {
                    name: "exportProductOtherdetailsProducerCountry",
                    label: "Country",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type:"autocomplete",
                    endpoint : "getCountry",
                }

            ],
            row7: [
                {
                    name: "exportProductOtherdetailsProducerState",
                    label: "State/Province",
                    component: "text-field",
                    type:"autocomplete",
                    endpoint:"getState",
                   dependsOn: "exportProductOtherdetailsProducerCountry",
                    
                }
            ],
            row8: [
                {
                    name: "exportProductOtherdetailsProducerPostalCode",
                    label: "Postal Code",
                    component: "text-field",
                }
            ],
            row9: [
                {
                    name: "exportProductOtherdetailsProducerSourceState",
                    label: "Source State",
                    component: "text-field",
                    endIconName: 'LuChevronDown',
                    iconColor: "gray-400",
                    defaultValue: "state",
                    type:"autocomplete",
                    endpoint:"getStateMaster",
                    
                   
                },
            ],
            row10: [
                {
                    name: "exportProductOtherdetailsProducerTransitCountry",
                    label: "Transit Country",
                    component: "text-field",
                    icon: LuSearch,
                    iconColor: "gray-400",
                    type:"autocomplete",
                    endpoint : "getCountry",
                }
            ]

        }
    }
]
}